import axios_ from "../utils/axios";
import { EventSourcePolyfill } from "event-source-polyfill";
import qs from "qs";
export default {
  getGptKey(param) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/getKey`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  // 敏感词
  getSensitive(query) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/tool/sensitiveTransfer`, query).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 写作 接口
   */
  async genderDocFromTmpl(text, distance, gpt_model_id) {
    let source = null;
    await this.getGptKey({
      text: text
    }).then(res => {
      if (res.code === 1) {
        source = new EventSourcePolyfill(`${process.env.VUE_APP_AI_API_URL}api/pandagpt/v1/writeInformationStorageChatStream?key=${res.data}&distance=${distance}&gpt_model_id=${gpt_model_id}`, {
          headers: {
            token: localStorage.getItem("token")
          },
          heartbeatTimeout: 1000 * 60 * 5 // 心跳超时时间，单位为毫秒
        });
      } else {
        source = {
          coddde: 0,
          msg: res.msg
        };
      }
    }).catch(error => {
      source = {
        coddde: 0,
        ...error
      };
    });
    return source;
  },
  /**
   * 对话页面问答接口
   * @param {*} text
   * @param {*} s_id 会话ID
   * @param {*} role_id 角色id
   * @param {*} gpt_model_id gpt模型id
   * @returns
   */
  chatStreamByLib(key, s_id, role_id, gpt_model_id) {
    let source = new EventSourcePolyfill(`${process.env.VUE_APP_AI_API_URL}api/pandagpt/v1/sess/informationChatStream?key=${key}&s_id=${s_id}&role_id=${role_id}&gpt_model_id=${gpt_model_id}`, {
      headers: {
        token: localStorage.getItem("token")
      },
      heartbeatTimeout: 1000 * 60 * 5 // 心跳超时时间，单位为毫秒
    });
    return source;
  },
  /**
   * 行业顾问 + 建议回复 事件流接口， 无上下文关联
   * @param {*} text
   * @param {number} distance 匹配知识库进准度
   * @param {Array} q_a_his ai 写作时，历史问答数据
   * @param {string} gpt_model_id gpt模型ID
   * @param {'3'|'4'|'5'|'6'|'7'|'8'} type 功能页面 3：在线客服 4：帖文助手 5：邮箱客服 6：行业顾问 7：建议答案 8：评论任务
   * @param {string} cs_id 客服ID
   * @param {1|2} is_unique 答案是否需要唯一,答案排重 1-需要；2-不需要
   * @returns
   */
  async adviserAndSuggestionStream(text, distance = "", q_a_his = [], gpt_model_id = "", type, cs_id = "", is_unique = 2) {
    let source = null;
    await this.getGptKey({
      text: text,
      q_a_his
    }).then(res => {
      if (res.code === 1) {
        let chatStreamQueryParams = {
          key: res.data,
          distance: distance,
          gpt_model_id,
          type,
          cs_id,
          is_unique
        };
        source = new EventSourcePolyfill(`${process.env.VUE_APP_AI_API_URL}api/pandagpt/v1/chatStream?${qs.stringify(chatStreamQueryParams, {
          encode: false
        })}`, {
          headers: {
            token: localStorage.getItem("token")
          },
          heartbeatTimeout: 1000 * 60 * 5 // 心跳超时时间，单位为毫秒
        });
      } else {
        source = {
          coddde: 0,
          msg: res.msg
        };
      }
    });
    return source;
  },
  /**
   * 对话页面获取会话列表
   * @param {*} page
   * @param {*} page_num
   * @param {*} sess_name 会话标题
   */
  getChats(options) {
    let {
      page,
      page_num,
      sess_name
    } = options;
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/sess/getChatSess`, {
        page: page,
        page_num: page_num,
        sess_name: sess_name
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 对话页面生成会话标题
   * @param {*} text
   * @param {*} s_id 会话ID
   */
  async createChatName(option) {
    let {
      text,
      s_id
    } = option;
    let source = null;
    await this.getGptKey({
      text: text
    }).then(res => {
      if (res.code === 1) {
        source = new EventSourcePolyfill(`${process.env.VUE_APP_AI_API_URL}api/pandagpt/v1/sess/createSessNameStream?key=${res.data}&s_id=${s_id}`, {
          headers: {
            token: localStorage.getItem("token")
          },
          heartbeatTimeout: 1000 * 60 * 5 // 心跳超时时间，单位为毫秒
        });
      } else {
        source = {
          coddde: 0,
          msg: res.msg
        };
      }
    });
    return source;
  },
  /**
   * 写作 生成标题
   * @param {*} text
   */
  async genderDocName(text, language) {
    let source = null;
    await this.getGptKey({
      text: text
    }).then(res => {
      if (res.code === 1) {
        source = new EventSourcePolyfill(`${process.env.VUE_APP_AI_API_URL}api/pandagpt/v1/createArticleTitle?key=${res.data}&language=${language}`, {
          headers: {
            token: localStorage.getItem("token")
          },
          heartbeatTimeout: 1000 * 60 * 5 // 心跳超时时间，单位为毫秒
        });
      } else {
        source = {
          coddde: 0,
          msg: res.msg
        };
      }
    });
    return source;
  },
  /**
   * 获取某个会话的历史问答
   * @param {*} page
   * @param {*} page_num
   * @param {*} s_id 会话ID
   * @param {*} scene 1：对话， 2：行业顾问
   * @returns
   */
  getChatHistory(options) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/sess/getChatSessHis`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取某个会话的对话角色
   * @param {*} sess_id 会话ID
   * @returns
   */
  getRoleDetailByChat(sess_id) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/pandagptRole/detailBySess`, {
        sess_id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 删除会话
   * @param {*} s_id
   */
  delChatSess(s_id) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/sess/delChatSess`, {
        s_id: s_id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 编辑会话名称
   * @param {*} s_id
   */
  uptSessStore(option) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/sess/uptSessStore`, option).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 角色列表-问题角色管理
   * @param {*} options
   * @returns
   */
  getChatRole(options) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/pandagptRole/lists`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 角色详情-问题角色管理
   * @param {*} options
   * @returns
   */
  getChatRoleDetail(id) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/pandagptRole/detail`, {
        id: id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 新增、编辑 角色-问题角色管理
   * @param {*} options
   * @param {*} type 1 新增 2 编辑
   * @returns
   */
  storeChatRole(options, type) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/pandagptRole/${type === 1 ? "store" : "uptStore"}`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 编辑问答角色排序
   * @param {*} options
   * @returns
   */
  chatRoleSortStore(options) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/pandagptRole/uptSort`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 删除角色-问题角色管理
   * @param {*} id
   * @returns
   */
  delChatRole(id) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/pandagptRole/del`, {
        id: id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 功能列表-常用功能-写作助手
   * @param {*} options
   * @returns
   */
  getChatCommand(options) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/pandagptCommand/lists`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 编辑指令-常用功能-写作助手
   * @param {*} options
   * @returns
   */
  setChatCommand(options) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/pandagptCommand/uptStore`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 模板列表-pandagpt模板设置
   * @param {*} options
   * @returns
   */
  getChatgptTemplates(options) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/pandagptTemplate/lists`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  // 历史指令列表-模板设置
  getcommandHistory(options) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/article/commandHistory`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 删除模板-pandagpt模板设置
   * @param {*} id
   * @returns
   */
  delChatgptTemplate(id) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/pandagptTemplate/del`, {
        id: id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 模板分类列表-pandagpt模板设置
   * @param {*} options
   * @returns
   */
  getChatgptTemplateClassify(options) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/pandagptTemplateClassify/lists`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 模板详情-pandagpt模板设置
   * @param {*} id
   * @returns
   */
  getChatgptTemplateDetail(id) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/pandagptTemplate/detail`, {
        id: id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 新增、编辑模板-常用功能-写作助手
   * @param {*} options
   * @returns
   */
  pandagptTemplateStore(options) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/pandagptTemplate/${options.id ? "uptStore" : "store"}`, options).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  articleList(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/article/lists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  articleSave(param) {
    let u_ = `api/pandagpt/v1/article/store`;
    if (param.id) {
      u_ = `api/pandagpt/v1/article/uptStore`;
    }
    return new Promise((resolve, reject) => {
      axios_("post", u_, param, true).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  articleTitleSave(param) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/article/setTitle`, param, true).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  articleDetail(id) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/article/detail`, {
        id: id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  articleDelete(id) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/article/del`, {
        id: id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  articleCopy(id) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/article/copyArticles`, {
        id: id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取 文章引用资料
   * @param {*} id
   * @returns
   */
  getReferences(id) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/article/getArticlesIndex`, {
        id: id
      }).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 修改文章设置
   * @param {*}
   * @returns
   */
  saveArticleConfig(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/article/saveConfig`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 选择资料作为上文进行总结的接口
   */
  async writeByInformationsStream(data) {
    let source = null;
    await this.getGptKey({
      information_ids: data.information_ids
    }).then(res => {
      if (res.code === 1) {
        source = new EventSourcePolyfill(`${process.env.VUE_APP_AI_API_URL}api/pandagpt/v1/writeChatStream?key=${res.data}&type=${data.type}`, {
          headers: {
            token: localStorage.getItem("token")
          },
          heartbeatTimeout: 1000 * 60 * 5 // 心跳超时时间，单位为毫秒
        });
      } else {
        source = {
          coddde: 0,
          msg: res.msg
        };
      }
    });
    return source;
  },
  /**
   * 客服关键词数据列表接口
   * @param {*} data
   * @returns
   */
  keywordRulelists(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/cs/keywordRulelists`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 新增客服关键词规则
   * @param {*} data
   * @returns
   */
  storeKeywordRule(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/cs/${data.rule_id ? "uptKeywordRule" : "createKeywordRule"}`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 删除机器人关键词规则
   * @param {*} data
   * @returns
   */
  delKeywordRule(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/cs/delKeywordRule`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 修改 关键词规则 启用状态
   * @param {*} data
   * @returns
   */
  changeKeywordRuleStatus(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/cs/switchKeywordRule`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 上传客服关键词图片
   * @param {FormData} formData
   * @returns
   */
  uploadKeywordImg(formData) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/cs/uploadKeywordImg`, formData, false, true).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 客服关键词详情
   * @param {*} data
   * @returns
   */
  keywordRuledetail(data) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/cs/keywordRuledetail`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 客服场景列表接口
   * @param {*} data
   * @returns
   */
  sceneLists(data) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/csScene/sceneLists`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 客服场景新增
   * @param {*} data
   * @returns
   */
  sceneStore(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/csScene/sceneStore`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 查询用户是否关注公众号
   * @param {*} data
   * @returns
   */
  getOaFollowStatus(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/wechatUser/getOaFollowStatus`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取二维码接口-微信登录接口-关注公众号登录
   * @param {*} data
   * @returns
   */
  getQrcodeImage(data) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/getQrcodeImage`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 客服场景列表删除
   * @param {*} data
   * @returns
   */
  sceneDelete(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/csScene/sceneDelete`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 客服场景更新
   * @param {*} data
   * @returns
   */
  sceneUpdate(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/csScene/sceneUpdate`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 客服场景详情
   * @param {*} data
   * @returns
   */
  sceneDetail(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/csScene/sceneDetail`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 客服回复语言设置
   * @param {*} data
   * @returns
   */
  getLanguageLists(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/cs/languageLists`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 添加回复语言设置
   * @param {*} data
   * @returns
   */
  languageInsert(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/cs/languageInsert`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 回复语言保存
   * @param {*} data
   * @returns
   */
  storeLanguage(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/cs/${data.id ? "languageUpdate" : "languageInsert"}`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 回复语言删除
   * @param {*} data
   * @returns
   */
  delLanguage(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/cs/languageDel`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 语种列表
   * @param {*} data
   * @returns
   */
  getToolLanguages(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/tool/getLanguage`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 翻译
   * @param {*} data
   * @returns
   */
  toolTranslate(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/tool/translate`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 共用附件上传；沿用 ImageUpload 方法名供已有图片调用方使用。
   * @param {FormData} FormData
   * @returns
   */
  ImageUpload(FormData) {
    return new Promise((resolve, reject) => {
      // tool/uploadImg 测试走 cn.emkol.cn，生产走 cn.joinmc.cn；同时保留 multipart 上传配置。
      axios_("POST", `api/pandagpt/v1/tool/uploadImg`, FormData, false, true, true).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 场景 是否启用
   * @param {*} data
   * @returns
   */
  updateSceneUseStatus(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/csScene/updateIsUse`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 新增客服
   * @param {InsertCSParams} params
   * @returns { Promise<{code:number;msg:string;data:any}> }
   */
  insertCs(params) {
    return axios_("POST", "api/pandagpt/v1/csScene/insertCs", params);
  },
  /**
   * 客服场景详情
   * @param {*} data
   * @returns
   */
  getReplyAnswers(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/csScene/getReplyAnswers`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * @typedef {Object} GetSceneRequest
   * @property {string} cs_id 机器人id
   * @property {string} [psid] 用户ID
   * @property {string} [post_id] 帖文ID
   * @property {string} [mail]
   * @property {string} cs_type 机器人类型  1：客服 2：帖文 3:邮箱
   * @property {string} cs_platform 平台 1：fb 2：ins 3：wsapp
   * @property {string} type 1 获取前三个 2 获取所有
   */
  /**
   * 获取场景
   * @param {GetSceneRequest} query
   * @returns {Promise<{code:number;msg:string;data:{scene_id:string;scene_name:string;scene_num:string}[]}>}
   */
  getCSuserScene(query) {
    return axios_("GET", "api/pandagpt/v1/csScene/getCSuserScene", query);
  }
};